module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', {
    staticClass: "moduleWrapper"
  }, [_c('md-card-content', {
    staticClass: "module"
  }, [_c('md-card', {
    staticClass: "card moduleTwo",
    class: {
      dark: _vm.slides[_vm.slidePosition].isDark, layoutTwo: _vm.slides[_vm.slidePosition].layout2, layoutThree: _vm.slides[_vm.slidePosition].layout3, layoutFour: _vm.slides[_vm.slidePosition].layout4, layoutFive: _vm.slides[_vm.slidePosition].layout5, listLeft: _vm.slides[_vm.slidePosition].listLeft, tourQuiz: _vm.slides[_vm.slidePosition].tourQuiz, listsText: _vm.slides[_vm.slidePosition].listsText, modeStart: _vm.slides[_vm.slidePosition].modeStart, tourSlide: _vm.slides[_vm.slidePosition].tour || _vm.slides[_vm.slidePosition].device
    },
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.slides[_vm.slidePosition].fadeImg) ? _c('img', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "device",
    attrs: {
      "src": _vm.slides[_vm.slidePosition].fadeImg,
      "alt": "Body Guard"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "copy"
  }, [(_vm.slides[_vm.slidePosition].fadeTitle) ? _c('h3', {
    key: _vm.slides[_vm.slidePosition].id
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].fadeTitle))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].fadeLists), function(list) {
    return _c('div', {
      key: _vm.slides[_vm.slidePosition].id
    }, [_vm._l((list.items), function(item) {
      return _c('p', {
        class: {
          bold: item.b, orange: item.o
        }
      }, [(item.span) ? _c('span', {
        class: {
          bold: item.b, orange: item.o
        }
      }, [_vm._v(_vm._s(item.span))]) : _vm._e(), _vm._v("\n                " + _vm._s(item.text) + "\n              ")])
    }), _vm._v(" "), _vm._l((list.links), function(link) {
      return _c('p', {
        class: {
          bold: link.b, orange: link.o
        },
        on: {
          "click": function($event) {
            _vm.jumpTo(link.jump)
          }
        }
      }, [_vm._v(_vm._s(link.a))])
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].lists), function(list) {
    return _c('ul', {
      key: _vm.slides[_vm.slidePosition].id
    }, [(list.title) ? _c('li', {
      staticClass: "listTitle"
    }, [_vm._v(_vm._s(list.title))]) : _vm._e(), _vm._v(" "), _vm._l((list.items), function(item) {
      return _c('li', {
        staticClass: "listItem",
        class: {
          bold: item.b, orange: item.o
        }
      }, [_vm._v(_vm._s(item.text))])
    })], 2)
  }), _vm._v(" "), (_vm.slides[_vm.slidePosition].fadeButton) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.incrementPosition($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].fadeButton) + " ")])], 1) : _vm._e()], 2), _vm._v(" "), (_vm.slides[_vm.slidePosition].tourQuiz) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "tourQuizText"
  }, [_c('p', {
    key: _vm.slides[_vm.slidePosition].id
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].text))]), _vm._v(" "), (_vm.slides[_vm.slidePosition].tourQuiz) ? _c('h3', [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].questionNo))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (_vm.slides[_vm.slidePosition].tourQuiz) ? _c('h4', [_vm._v(_vm._s(tip.question))]) : _vm._e()
  }), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('p', {
    staticClass: "feedback"
  }, [_c('span', [_vm._v("?")]), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct === false) ? _c('p', {
    staticClass: "feedback"
  }, [_c('span', [_vm._v("X")]), _vm._v("Incorrect")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.img) ? _c('img', {
      key: _vm.slides[_vm.slidePosition].id,
      staticClass: "device-tip",
      class: {
        current: tip.current
      },
      attrs: {
        "src": tip.img,
        "alt": "Body Guard"
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('ul', {
      key: _vm.slides[_vm.slidePosition].id,
      class: {
        current: tip.current
      }
    }, [_c('li', {
      staticClass: "tipTitle"
    }, [_vm._v(_vm._s(tip.title))]), _vm._v(" "), _vm._l((tip.items), function(item) {
      return _c('li', {
        staticClass: "tipItem",
        class: {
          bold: item.b, orange: item.o
        }
      }, [_vm._v(_vm._s(item.text))])
    }), _vm._v(" "), (tip.lists) ? _c('ul', {
      staticClass: "tipList"
    }, _vm._l((tip.lists), function(list) {
      return _c('li', [_vm._v(_vm._s(list.text))])
    })) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "glow"
  }, [_vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.bar) ? _c('div', {
      staticClass: "glowButton",
      class: {
        bar: tip.bar, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.stopButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        stopButton: tip.stopButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.startButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        startButton: tip.startButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.primeButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        primeButton: tip.primeButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.powerButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        powerButton: tip.powerButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.lockButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        lock: tip.lockButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.infoButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        infoButton: tip.infoButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.numbers) ? _c('div', {
      staticClass: "glowButton",
      class: {
        numbers: tip.numbers, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.arrows) ? _c('div', {
      staticClass: "glowButton",
      class: {
        arrows: tip.arrows, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.LED) ? _c('div', {
      staticClass: "glowButton",
      class: {
        LED: tip.LED, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), (_vm.slides[_vm.slidePosition].tourQuiz) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "tourQuiz"
  }, [_vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        bar: tip.bar, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('bar')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        barLeft: tip.barLeft, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('barLeft')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        barRight: tip.barRight, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('barRight')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        bolus: tip.bolus, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('bolus')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        rate: tip.rate, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('rate')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        stopButton: tip.stopButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('stop')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        startButton: tip.startButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('start')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        primeButton: tip.primeButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('prime')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        powerButton: tip.powerButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('power')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        lock: tip.lockButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('lock')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        infoButton: tip.infoButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('info')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        numbers: tip.numbers, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('numbers')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        arrows: tip.arrows, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('arrows')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        LED: tip.LED, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('LED')
        }
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].quiz) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "quiz"
  }, [_c('h3', [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].question))]), _vm._v(" "), (_vm.slides[_vm.slidePosition].multiAnswer) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer1",
      "value": "right"
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer2",
      "value": "right"
    },
    model: {
      value: (_vm.answer2),
      callback: function($$v) {
        _vm.answer2 = $$v
      },
      expression: "answer2"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[2]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer3",
      "value": "right"
    },
    model: {
      value: (_vm.answer3),
      callback: function($$v) {
        _vm.answer3 = $$v
      },
      expression: "answer3"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[2].text))]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.checkAnswer($event)
      }
    }
  }, [_vm._v("Check Answer")]), _vm._v(" "), (_vm.correct) ? _c('p', {
    staticClass: "feedback"
  }, [_vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.incorrect) ? _c('p', {
    staticClass: "feedback"
  }, [_vm._v("Incorrect")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].singleAnswer) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-radio', {
    attrs: {
      "id": "answer1",
      "name": "group1",
      "md-value": "1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.answer($event)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-radio', {
    attrs: {
      "id": "answer2",
      "name": "group1",
      "md-value": "2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.answer($event)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[2]) ? _c('md-radio', {
    attrs: {
      "id": "answer3",
      "name": "group1",
      "md-value": "3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.answer($event)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[2].text))]) : _vm._e(), _vm._v(" "), (_vm.correct) ? _c('p', {
    staticClass: "feedback"
  }, [_vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.incorrect) ? _c('p', {
    staticClass: "feedback"
  }, [_vm._v("Incorrect")]) : _vm._e()], 1) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "slide-left"
    }
  }, [_vm._l((_vm.slides[_vm.slidePosition].lines), function(line) {
    return _c('p', {
      key: _vm.slides[_vm.slidePosition].id,
      class: {
        bold: line.b
      }
    }, [_vm._v(_vm._s(line.text))])
  }), _vm._v(" "), _c('a', {
    key: _vm.slides[_vm.slidePosition].id,
    attrs: {
      "href": _vm.slides[_vm.slidePosition].linkHref,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].linkText))]), _vm._v(" "), (_vm.slides[_vm.slidePosition].img) ? _c('img', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "device",
    attrs: {
      "src": _vm.slides[_vm.slidePosition].img,
      "alt": "Body Guard"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].img2) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "shiftWrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.slides[_vm.slidePosition].img2,
      "alt": "Body Guard"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].video) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "video"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "height": "0",
      "padding-bottom": "75.0%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "left": "0"
    },
    attrs: {
      "src": _vm.slides[_vm.slidePosition].video,
      "width": "480",
      "height": "360",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].button) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.incrementPosition($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].button) + " ")])], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "progress"
    }
  }, [_c('div', {
    staticClass: "slideWrap"
  }, [_c('md-progress', {
    attrs: {
      "md-progress": _vm.progressPercent
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "progText"
  }, [_vm._v("Progress "), _c('b', [_vm._v(_vm._s(Math.trunc(_vm.progressPercent)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "progNav"
  }, [_c('router-link', {
    attrs: {
      "to": "/front"
    }
  }, [_c('img', {
    staticClass: "home",
    attrs: {
      "src": require("../assets/home.svg"),
      "alt": "Front Page"
    }
  })]), _vm._v(" "), (_vm.notFirstSlide) ? _c('div', [_c('div', {
    staticClass: "imgWrap next",
    class: {
      disabled: _vm.disableBtn, tourHide: _vm.tourStarting, quizDisable: _vm.quizDisable, moduleEnd: _vm.moduleEnd
    },
    on: {
      "click": function($event) {
        _vm.incrementPosition(_vm.slidePosition)
      }
    }
  }, [_c('p', [_vm._v("Next")]), _c('img', {
    attrs: {
      "src": require("../assets/arrow-right-thick.svg"),
      "alt": "Next"
    }
  })]), _vm._v(" "), (_vm.moduleEnd) ? _c('div', {
    staticClass: "imgWrap next"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-7"
    },
    nativeOn: {
      "click": function($event) {
        _vm.moduleComplete(6, 7)
      }
    }
  }, [_c('p', [_vm._v("Next")]), _c('img', {
    attrs: {
      "src": require("../assets/arrow-right-thick.svg"),
      "alt": "Next"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgWrap prev md-disabled",
    on: {
      "click": _vm.decrementPosition
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/arrow-left-thick.svg"),
      "alt": "Prev"
    }
  }), _c('p', [_vm._v("Prev")])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dea2856"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Module6.vue
// module id = 756
// module chunks = 0